<script>
    import {votingUnits, tooltip, activeData, currentRound} from "../stores";
    import {Cities} from "vpap/svelte/leaflet/defaults";
    import {sortedGeography} from "vpap/common/geo";

    function sortFunc(a, b) {
        const votesDiff = b[votesKey] - a[votesKey];
        if (votesDiff === 0) return b.cand_name < a.cand_name ? 1 : -1;
        else return votesDiff;
    }

    function handleMouseOver(data) {
        const unitVotes = getUnitVotes(data);
        const sortedVotes = unitVotes.sort(sortFunc)
            .map(d => {
                return {
                    cand_name: d.cand_name,
                    cand_color: d.cand_color,
                    votes: d[votesKey],
                    pct: d[pctKey]
                }
            });
        tooltip.updateData({
            unit_name: data.properties.unit_name,
            candidates: sortedVotes,
            votes_type: section
        });
        tooltip.show();
    }

    function handleFocus(e, data) {
        const bbox = e.target.getBoundingClientRect();
        tooltip.changePosition(bbox.left, bbox.bottom);
        return handleMouseOver(data);
    }

    function handleKeyDown(e, data) {
        if (e.code === "Space" || e.code === "Enter") {
            return handleFocus(e, data);
        }
        if (e.code === "Escape") {
            return tooltip.hide();
        }
    }

    export let section;
    export let projection;
    export let mapZoom;

    $: votesKey = section === "overall" ? "votes" : "redistributed_votes";
    $: pctKey = section === "overall" ? "votes_percent" : "redistributed_percent";
    
    function getUnitVotes(d) {
        if (!$activeData.results_detail[$currentRound]) {
            return [];
        }
        const valAtId = $activeData.results_detail[$currentRound].units[d.properties.unit_id];
        if (!valAtId) {
            return [];
        }
        return valAtId;
    }

    function fill(d) {
        const unitVotes = getUnitVotes(d);
        // indicates empty data
        if (unitVotes.length === 0) return "#ddd";
        const sortedVotes = unitVotes.sort(sortFunc);
        // leave blank if no votes yet
        if (sortedVotes[0][votesKey] === 0) return "#ddd";
        // indicates tie
        if (sortedVotes.length >= 2 && sortedVotes[0][votesKey] === sortedVotes[1][votesKey]) return "#8b4513";
        return sortedVotes[0].cand_color || "#ddd";
    }
</script>

{#key [$currentRound, $activeData.results_detail]}
<g class="chloropleth">
    {#each $votingUnits.features.sort(sortedGeography(projection)) as unit}
    <path 
        d={projection(unit)}
        fill={fill(unit)}
        on:mouseover={() => handleMouseOver(unit)}
        on:focus={(e) => handleFocus(e, unit)}
        on:mouseleave={tooltip.hide}
        on:blur={tooltip.hide} 
        on:mousemove={tooltip.mousemove}
        on:keydown={(e) => handleKeyDown(e, unit)}
        stroke-width={mapZoom ? mapZoom === 5 ? 0.4 : mapZoom === 6 ? 0.7 : 1 : 1}
        tabindex="0"
    >
    </path>
    {/each}
</g>
{/key}
<Cities {projection}/>

<style lang="scss">
    path {
        fill-opacity: .8;
        stroke: #A3A3A3;
        pointer-events: all !important;

        &:focus, &:hover {
            fill-opacity: 1;
            stroke-width: 2;
        }
    }
</style>